import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';
export function StickyBar() {
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 px-4 z-50 shadow-lg" data-id="element-254">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-semibold" data-id="element-255">
        <AlertTriangle className="w-5 h-5 animate-pulse" data-id="element-256" />
        <span className="text-center" data-id="element-257">
          WARNING: 75% OFF Sale Ends Tonight. Help your dog find peace before
          the next work week starts.
        </span>
      </div>
    </motion.div>;
}